<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        data-cy="close-modal-button"
        class="close-modal-button"
        (click)="closeModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-label data-cy="po-number-title-label">
      {{ title }}
    </ion-label>
  </ion-toolbar>

  <ion-button
    *ngIf="platformService?.isTouchExperience$ | async"
    class="touch-exit-btn"
    id="close-modal-btn"
    data-cy="close-mobile-modal-button"
    (click)="closeModal()"
  >
    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
  </ion-button>
</ion-header>

<app-change-po
  (titleIdentified)="onTitleIdentified($event)"
  (poUpdated)="onPoUpdate()"
  [platform]="platformService?.platformType"
></app-change-po>
